import React, { useCallback, useState } from 'react';
import AreYouSure from './AreYouSure';
import Buffer56 from './Buffer56';
import useWebSocketCaller from '../../../hooks/useWebSocketCaller';
import FolderCommander from './FolderCommander';
import { useConfigPathContext } from '../../../providers/ConfigPathContextProvider';
import './ConfigFolderLabel.css';


const ConfigFolderLabel = ({parentFolderPath, folderName, switchToEdit}) => {
  const {setConfigPath} = useConfigPathContext();
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const confirmDelete = useCallback(() => setShowConfirmDelete(true), []);
  const cancelConfirmDelete = useCallback(() => setShowConfirmDelete(false), []);
  const {sendMessage} = useWebSocketCaller();

  //------  Delete Folder  ------
  //
  const submitDeleteFolder = useCallback(() => {
    sendMessage('delete-config-folder', {
      basePath: parentFolderPath,
      folderName: folderName
    });
  }, [sendMessage, parentFolderPath, folderName]);


  //------ Folder Clicked  ------
  //
  const onFolderClicked = () => {
    setConfigPath(prev => `${prev}['${folderName}']`);
  }


  // ------  Render  ------
  
  return (
    <div className='configFolderLabelWrap'>

      <FolderCommander confirmDelete={confirmDelete} editFolderName={switchToEdit}/>

      {showConfirmDelete && 
      <div>
        <AreYouSure hideMe={cancelConfirmDelete} applyMe={submitDeleteFolder}/>
        <Buffer56 />
      </div>
      }

      <div className='configFolderLabel' onClick={onFolderClicked}>
        {folderName}
      </div>
    </div>
  );
};

export default ConfigFolderLabel;